import { render } from "./basenotificationcard.vue?vue&type=template&id=00c9d480&scoped=true"
import script from "./basenotificationcard.vue?vue&type=script&lang=js"
export * from "./basenotificationcard.vue?vue&type=script&lang=js"

import "./basenotificationcard.vue?vue&type=style&index=0&id=00c9d480&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c9d480"]])

export default __exports__